export const sectorData = {
    food: {
      current: {
        dairyConsumption: {
          reduction: 0,
          impact: 3,
          description: 'Standard dairy consumption'
        },
        meatConsumption: {
          reduction: 0,
          impact: 5,
          description: 'Typical meat intake'
        },
        plantBasedDiet: {
          reduction: 0,
          impact: 2,
          description: 'Minimal plant-based meals'
        },
        totalImpact: 10
      },
      low: {
        dairyConsumption: {
          reduction: 40,
          impact: 1.8,
          description: 'Significant dairy reduction'
        },
        meatConsumption: {
          reduction: 50,
          impact: 2.5,
          description: 'Substantial meat reduction'
        },
        plantBasedDiet: {
          reduction: 30,
          impact: 1.4,
          description: 'Predominantly plant-based diet'
        },
        totalImpact: 5.7
      },
      high: {
        dairyConsumption: {
          reduction: 15,
          impact: 2.5,
          description: 'Reduced dairy consumption'
        },
        meatConsumption: {
          reduction: 20,
          impact: 4,
          description: 'Moderate meat reduction'
        },
        plantBasedDiet: {
          reduction: 10,
          impact: 1.8,
          description: 'Increased plant-based meals'
        },
        totalImpact: 8.3
      }
    },
    buildings: {
      current: {
        heatPumpAdoption: {
          reduction: 0,
          impact: 4,
          description: 'Minimal heat pump usage'
        },
        rentalPropertyEfficiency: {
          reduction: 0,
          impact: 3,
          description: 'Basic property efficiency'
        },
        newBuildZeroCarbon: {
          reduction: 0,
          impact: 2,
          description: 'Few zero-carbon builds'
        },
        totalImpact: 9
      },
      low: {
        heatPumpAdoption: {
          reduction: 40,
          impact: 2.4,
          description: 'Widespread heat pump adoption'
        },
        rentalPropertyEfficiency: {
          reduction: 30,
          impact: 2.1,
          description: 'Comprehensive efficiency upgrades'
        },
        newBuildZeroCarbon: {
          reduction: 20,
          impact: 1.6,
          description: 'Majority zero-carbon builds'
        },
        totalImpact: 6.1
      },
      high: {
        heatPumpAdoption: {
          reduction: 15,
          impact: 3.4,
          description: 'Moderate heat pump adoption'
        },
        rentalPropertyEfficiency: {
          reduction: 10,
          impact: 2.7,
          description: 'Improved property efficiency'
        },
        newBuildZeroCarbon: {
          reduction: 5,
          impact: 1.9,
          description: 'Some zero-carbon builds'
        },
        totalImpact: 8
      }
    },
    transport: {
      current: {
        publicTransportUsage: {
          reduction: 0,
          impact: 5,
          description: 'Limited public transport'
        },
        flightReduction: {
          reduction: 0,
          impact: 6,
          description: 'Regular flight patterns'
        },
        electricVehicleAdoption: {
          reduction: 0,
          impact: 4,
          description: 'Few electric vehicles'
        },
        totalImpact: 15
      },
      low: {
        publicTransportUsage: {
          reduction: 50,
          impact: 2.5,
          description: 'Extensive public transport'
        },
        flightReduction: {
          reduction: 60,
          impact: 2.4,
          description: 'Significant flight reduction'
        },
        electricVehicleAdoption: {
          reduction: 40,
          impact: 2.4,
          description: 'Majority electric vehicles'
        },
        totalImpact: 7.3
      },
      high: {
        publicTransportUsage: {
          reduction: 20,
          impact: 4,
          description: 'Increased public transport'
        },
        flightReduction: {
          reduction: 25,
          impact: 4.5,
          description: 'Reduced flight frequency'
        },
        electricVehicleAdoption: {
          reduction: 15,
          impact: 3.4,
          description: 'Growing EV adoption'
        },
        totalImpact: 11.9
      }
    },
    industry: {
      current: {
        productLongevity: {
          reduction: 0,
          impact: 3,
          description: 'Standard product lifecycles'
        },
        industrialEnergyEfficiency: {
          reduction: 0,
          impact: 4,
          description: 'Basic efficiency measures'
        },
        materialCircularity: {
          reduction: 0,
          impact: 3,
          description: 'Limited recycling'
        },
        totalImpact: 10
      },
      low: {
        productLongevity: {
          reduction: 40,
          impact: 1.8,
          description: 'Significantly extended lifecycles'
        },
        industrialEnergyEfficiency: {
          reduction: 50,
          impact: 2,
          description: 'Advanced efficiency strategies'
        },
        materialCircularity: {
          reduction: 30,
          impact: 2.1,
          description: 'Advanced circular economy'
        },
        totalImpact: 5.9
      },
      high: {
        productLongevity: {
          reduction: 15,
          impact: 2.5,
          description: 'Extended product lifecycles'
        },
        industrialEnergyEfficiency: {
          reduction: 20,
          impact: 3.2,
          description: 'Improved efficiency strategies'
        },
        materialCircularity: {
          reduction: 10,
          impact: 2.7,
          description: 'Increased recycling efforts'
        },
        totalImpact: 8.4
      }
    }
  };